import React from "react";
import { uplusState } from "../../../../../Enum/state.Enum";
import Flex from "../../../../DefaultStyles/Flex";
import { Input } from "../../../../Input/Input";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { StatusArrow } from "../UplusMatchingStatusChangeModal";

interface UplusMatchingStatusAskModalProps extends DefaultModalCommonProps {
  nowStatus?: string;
  changeStatus?: string;
  targetCnt?: number;
}

export default function UplusMatchingStatusAskModal({
  closeEvent,
  confirmEvent,
  nowStatus,
  changeStatus,
  targetCnt,
}: UplusMatchingStatusAskModalProps) {
  return (
    <DefaultModalLayout
      modalTitle="결합 상태 변경"
      closeEvent={() => closeEvent()}
      isSmallModal={true}
      confirmEvent={() => {
        if (confirmEvent) confirmEvent();
      }}
      modalDesc={`결합 상태를 변경하는 즉시 고객의 파티 상태가 변경되고,
알림이 전송됩니다.`}
      confirmBtnColor="red"
      cancelBtnText="취소"
      confirmBtnText="변경"
    >
      <ModalRow>
        <ModalLabel>상태</ModalLabel>

        <Flex gapSize={10}>
          <Input value={nowStatus} readOnly={true} />

          <StatusArrow
            src={require("../../../../../assets/dropDown/arrow_drop_down_black_24.png")}
          />

          <Input value={changeStatus} readOnly={true} />
        </Flex>
      </ModalRow>

      <ModalRow>
        <ModalLabel style={{ width: 93 }}>변경 대상</ModalLabel>

        <Input value={`${targetCnt ?? 0}명`} readOnly={true} />
      </ModalRow>
    </DefaultModalLayout>
  );
}
